import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Shield, Download } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-12 pb-20 px-4 md:pt-20 md:pb-28 overflow-hidden" data-id="element-73">
      <div className="max-w-6xl mx-auto" data-id="element-74">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-75">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left" data-id="element-76">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 text-balance" data-id="element-77">
              Diaper-Free in 72 Hours
              <span className="block text-2xl md:text-3xl lg:text-4xl text-secondary mt-2 font-medium italic" data-id="element-78">
                (Guaranteed)
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground/80 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-79">
              The "Accelerated Immersion" weekend method for moms who need their
              child out of diapers before Daycare or Pre-K starts.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-80">
              <Button size="xl" animate onClick={scrollToOffer} className="w-full sm:w-auto text-wrap text-center py-4 h-auto min-h-[4rem]" data-id="element-81">
                YES — GET MY CHILD DIAPER-FREE NOW
              </Button>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 w-full max-w-lg lg:max-w-none relative" data-id="element-82">
            <div className="absolute inset-0 bg-secondary/10 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-83"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ox8PTqKk4WJyvyA2GfsGXw/Diaper_Free_in_72_Hours.png" alt="Mother and child playing with blocks, diaper-free in 72 hours" className="w-full h-auto rounded-3xl shadow-soft border-4 border-white object-cover aspect-square md:aspect-[4/3] lg:aspect-square" data-id="element-84" />
          </motion.div>
        </div>
      </div>
    </section>;
}